<template>
    <span class="click-radio" @click="$emit('input', !value)">
        <span class="radio-outer">
            <span class="radio-inner" v-show="value"></span>
        </span>
        <span class="radio-label">
            <slot></slot>
        </span>
    </span>
</template>

<script>
    export default {
        name: "clickRadio",
        props: {
            value: Boolean
        },
    }
</script>

<style scoped lang="scss">
@import "../styles/element-variables";
@media screen and (max-width: $--media-max-width){
    .click-radio {
        .radio-outer {
            width: 0.1rem;
            height: 0.1rem;
        }
        .radio-label {
            font-size: 0.1067rem;
            margin-left: 0rem;
        }
    }
}
.radio-outer {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    border-color: $--color-primary;
    border-style: solid;
    border-width: 1px;
    display: inline-block;
    position: relative;
    vertical-align: middle;
}
.radio-inner {
    position: absolute;
    background-color: $--color-primary;
    width: 50%;
    height: 50%;
    border-radius: 50%;
    top: 25%;
    left: 25%;
}
.click-radio {
    color: $--color-primary;
    cursor: pointer;
}
.radio-label {
    vertical-align: middle;
    margin-left: 13px;
    font-size: 22px;
    font-weight: 500;
}
</style>
